import CommonAgGrid, { bombyxAgTheme } from './CommonAgGrid';

export { bombyxAgTheme };
export type { CommonAgGridProps } from './types';
export default CommonAgGrid;
